import { Chip } from "@mui/material";

import getNameInitials from "utils/getNameInitials";

import { StorageBuckets } from "api/storage";
import useBoundStore from "store";
import AsyncAvatar from "../AsyncAvatar";
import styles from "./chipList.module.scss";

export interface ChipProps {
  avatar: string | null;
  name: string | null;
}
export interface ChipListProps<T> {
  chips: T[];
  onDelete: (chip: T) => void;
}

function ChipList<T extends ChipProps>(props: ChipListProps<T>) {
  const { chips, onDelete } = props;
  const smallAvatars = useBoundStore((state) => state.miscellaneous.smallAvatars);

  return chips?.map((chip, index) => (
    <Chip
      key={index}
      variant='outlined'
      color='primary'
      label={chip.name}
      onDelete={() => onDelete(chip)}
      avatar={
        <AsyncAvatar
          avatarFile={chip.avatar ? smallAvatars[chip.avatar] : undefined}
          avatarName={chip.avatar}
          placeholder={getNameInitials(chip.name, 1)}
          bucket={StorageBuckets.PROFILES_AVATARS}
        />
      }
      className={styles.chip}
    />
  ));
}

export default ChipList;
